import { getANMS, getBidderEmail, getBidderId, getUserFullName, isProfileComplete } from '@/redux/modules/user';
import { useEffect, useState } from 'react';
import { getIsBidderCardValid } from '@/redux/modules/bidderCardStatus';
import { getLogRocketAppId } from '@/redux/modules/config';
import LogRocketLib from 'logrocket';
import { useSelector } from 'react-redux';

/**
 * Initialize LogRocket client and identify the logged-in user
 * @see https://docs.logrocket.com/docs/getting-started
 */
const LogRocket = () => {
    const [startLogging, setStartLogging] = useState(false);

    // Get data to identify user
    const ANMS = useSelector(getANMS);
    const bidderId = useSelector(getBidderId);
    const creditCardValidated = useSelector(getIsBidderCardValid);
    const email = useSelector(getBidderEmail);
    const fullName = useSelector(getUserFullName);
    const profileComplete = useSelector(isProfileComplete);

    // Key to connect to LogRocket
    const logRocketAppId = useSelector(getLogRocketAppId);

    // Initialize LogRocket and identify user only after 30 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setStartLogging(true);
        }, 30000);

        return () => clearTimeout(timer);
    }, []);

    // If not in development mode, its been 30 seconds and the user is loaded
    // start recording to LogRocket and identify user
    useEffect(() => {
        if (!__DEVELOPMENT__) {
            if (startLogging && bidderId > 0) {
                // Initialize client
                LogRocketLib.init(logRocketAppId);

                // Identify user
                LogRocketLib.identify(bidderId.toString(), {
                    ANMS,
                    creditCardValidated,
                    email,
                    name: fullName,
                    profileComplete,
                });
            }
        }
    }, [ANMS, bidderId, creditCardValidated, email, fullName, logRocketAppId, profileComplete, startLogging]);

    return null;
};

export default LogRocket;
